import React from "react";
import { Link, LinkProps } from "react-router-dom";

import { useWizards } from "./WizardProvider";

/**
 * Navigates elsewhere in the app and minimizes the wizard so the linked
 * page is usable. The session stays in the dock to come back to.
 */
export function WizardLink({ onClick, ...rest }: LinkProps) {
  const { minimizeWizard } = useWizards();
  return (
    <Link
      {...rest}
      onClick={(event) => {
        onClick?.(event);
        minimizeWizard();
      }}
    />
  );
}
